import {
    ContainerDataType,
    ContainerType,
    JSONAnnotationDataType,
    RoleType,
    SourceType,
} from 'Types/Tasks.types'
import { IContainerStrategy } from '../ContainerStrategy'
import { JSONAnnotationTask } from 'Tasks/JSONAnnotation/JSONAnnotationTask'
import { cloneDeep } from 'lodash'

export class JSONAnnotationContainerStrategy
    implements IContainerStrategy<ContainerType.JSONAnnotation, JSONAnnotationDataType>
{
    containerContext?: {
        task: JSONAnnotationTask
    }

    setContext(containerContext: { task: JSONAnnotationTask }) {
        this.containerContext = containerContext
    }

    getEmptyDraftContainer(): ContainerDataType<
        ContainerType.JSONAnnotation,
        JSONAnnotationDataType
    > {
        return {
            data: {
                schema_version: 1,
                type: ContainerType.JSONAnnotation,
                data: {
                    quality_check: {
                        evaluation_on_response_version_id: {},
                    },
                    response: {
                        id: crypto.randomUUID(),
                        version_id: null,
                        role: RoleType.ASSISTANT,
                        source: SourceType.HUMAN,
                        extra_info: {},
                        json_annotations: {},
                    },
                },
            },
        }
    }

    getModifiedDraftOutputContainer = (
        draftOutputContainer: ContainerDataType<
            ContainerType.JSONAnnotation,
            JSONAnnotationDataType
        >
    ) => {
        return cloneDeep(draftOutputContainer)
    }

    getContainerFromOutputStart = (
        outputStartContainer: ContainerDataType<
            ContainerType.JSONAnnotation,
            JSONAnnotationDataType
        >
    ) => {
        const draftContainer = cloneDeep(outputStartContainer)

        if (draftContainer) {
            draftContainer.data.data.quality_check.evaluation_on_response_version_id = {}
            draftContainer.decision = null
        }

        return draftContainer
    }
}
